import type { FunctionComponent } from 'react';

import styles from './Box.module.less';

const Box: FunctionComponent = ({ children }) => (
  <div className={styles.box}>{children}</div>
);

export default Box;
